import React, { Component } from 'react';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

class ResponsiveImage extends Component {
  render() {
    if (this.props.height === 0 || this.props.width === 0) {
      return null;
    }

    let defaultSize = null;
    let sizes = [];
    let percent = null;

    if (!Array.isArray(this.props.defaultSize)) {
      // We have only width, just scale the image without cropping
      if (this.props.width >= this.props.defaultSize) {
        defaultSize = `${this.props.url}?w=${this.props.defaultSize}`;
      } else {
        defaultSize = this.props.url;
      }

      percent = `${Math.floor(this.props.height / this.props.width * 100)}%`;

      let sizes = this.props.sizes.filter(size => {
        return size <= this.props.width;
      });

      // Add original image size into the srcset if it's not in already
      if (!sizes.includes(this.props.width)) {
        sizes.push(this.props.width);
      }

      sizes = sizes.map(size => {
        return `${this.props.url}?w=${size} ${size}w`;
      });
    } else {
      // We have width and height so we crop the image
      if (
        this.props.width >= this.props.defaultSize[0] &&
        this.props.height >= this.props.defaultSize[1]
      ) {
        defaultSize = `${this.props.url}?w=${this.props.defaultSize[0]}&h=${
          this.props.defaultSize[1]
        }&mode=crop`;
      } else {
        defaultSize = `${this.props.url}?w=${this.props.height}&h=${this.props
            .height *
            (this.props.defaultSize[1] / this.props.defaultSize[0])}&mode=crop`;          
      }

      percent = `${Math.floor(
        this.props.defaultSize[0] / this.props.defaultSize[1] * 100
      )}%`;

      sizes = this.props.sizes.filter(size => {
        return size <= this.props.width;
      });

      // Scale original image to aspect ratio
      let scaleHeight = this.props.height / this.props.defaultSize[1];
      let scaleWidth = this.props.width / this.props.defaultSize[0];

      let scale = Math.min(scaleHeight, scaleWidth);

      let scaledHeight = Math.floor(this.props.defaultSize[1] * scale);
      let scaledWidth = Math.floor(this.props.defaultSize[0] * scale);

      // If we don't have the same size as a breakpoint, add the size to srcset
      if (!sizes.includes(scaledWidth)) {
        sizes.push(scaledWidth);
      }

      sizes = sizes.map(size => {
        let height =
          size * (this.props.defaultSize[1] / this.props.defaultSize[0]);
        if (height <= this.props.height && size <= this.props.width) {
          return `${this.props.url}?w=${size}&h=${height}&mode=crop ${size}w`;
        } else {
          return null;
        }
      });

      // Drop nulls
      sizes = _.compact(sizes);
    }

    sizes = sizes.join(', ');

    let alt = this.props.alt ? this.props.alt : '';

    return (
      <div className="responsive-image" style={{ paddingBottom: percent }}>
        <img
          className="lazyload responsive-image-child"
          data-sizes="auto"
          data-src={defaultSize}
          data-srcset={sizes}
          alt={alt}
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
        />
      </div>
    );
  }
}

export default ResponsiveImage;
